import { Injectable, Inject } from '@angular/core';
import { ITravelType } from './ITravelType';
import { HttpClient } from '@angular/common/http';
import { LoggingService } from '../shared/services/logging/logging.service';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TravelTypeLookupService {

  constructor(@Inject(HttpClient) private http: HttpClient
    , @Inject(LoggingService) private log: LoggingService) {
  }
  uri = `${environment.apiLocation}/TravelType`;

  public get (): Observable<Array<ITravelType>> {
    const params = {};

    this.log.verbose({ type: 'TravelTypeLookupService:get', uri: this.uri });
    return this.http.get<Array<ITravelType>>(this.uri)
      .pipe(
        tap(res => this.log.verbose({ type: 'TravelTypeLookupService:reponse', res }))
      );
  }
}
